<template>
  <section>
    <div class="home">
      <div
        class="d-flex justify-content-center align-items-center container-fluid"
      >
        <div class="know">
          <h2 class="lorme text-white text-align-center">Get to know us</h2>
          <p class="text-white text-align-center small">
            Learn about our story: Our company was founded with a mission to
            make a difference, and we've come a long way since then. Get to know
            our history, our values, and the journey that's led us to where we
            are today.
          </p>
        </div>
      </div>
      <div
        class="d-flex justify-content-center align-items-center d-none d-md-none"
      >
        <router-link class="contact-text" to="/contact">Contact Us</router-link>
      </div>
    </div>
  </section>
  <section class="who">
    <div class="container-fluid pb-5">
      <div class="row">
        <div
          class="col-lg-6 col-md-6 col-sm-12 d-flex align-items-center justify-content-center story"
        >
          <div class="text-align-center align-items-center">
            <h1 class="sixty">Who we are</h1>
            <div class="mt-1 small">
              <p>
                At Fhenix Africa, we are passionate about empowering individuals
                and organizations with the latest tech skills.
              </p>
              <p>
                We offer comprehensive training programs that cover a range of
                tech skills, including Android development, web development,
                data science, UI/UX design, computer-aided design (CAD),
                programming foundation, embedded systems, and digital marketing.
              </p>
              <p>
                Our experienced instructors provide hands-on training and
                mentorship to help our students develop practical skills and
                build their portfolios. In addition to our training programs, we
                also offer talent outsourcing services, corporate training, and
                co-working space.
              </p>
              <p>
                Join us and let us help you unlock your potential and achieve
                your tech goals.
              </p>

              <!-- <p
                class="text-primary"
                v-if="!readMoreActivated"
                role="button"
                @click="readMoreActivated = true"
                href="#"
              >
                See More...
              </p>
              <p
                class="text-primary"
                v-else
                role="button"
                @click="readMoreActivated = false"
                href="#"
              >
                See Less...
              </p> -->
            </div>
          </div>
        </div>

        <div
          class="picture col-lg-6 col-md-6 col-sm-12 d-flex align-items-center mt-5"
        >
          <div>
            <div class="portfolio-wrap text-white mt-3 circle">
              <img
                src="../assets/Images/picc2.jpg"
                alt=""
                class="shadow img-fluid red"
              />
            </div>
            <div class="portfolio-wrap text-white ml-3 mt-3">
              <img
                src="../assets/Images/picc3.jpg"
                alt=""
                class="shadow img-fluid people"
              />
            </div>
          </div>
          <div>
            <div class="portfolio-wrap text-white">
              <img
                src="../assets/Images/picc1.jpg"
                alt=""
                class="iron shadow img-fluid iron"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- <section class="handle pt-5 pb-5">
    <div
      class="d-flex justify-content-center align-items-center container-fluid pt-5 values"
    >
      <div class="text-align-center hood">
        <div>
          <h1 class="text-align-center sixty">Our Values</h1>
          <p class="text-align-center pr-3 small">
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Dolores
            assumenda aspernatur voluptate. Ducimus, libero natus.
          </p>
        </div>
        <swiper
          class="fox"
          :slides-per-view="1"
          :space-between="50"
          :autoplay="{
            delay: 2500,
            disableOnInteraction: false,
          }"
          :pagination="{
            clickable: true,
          }"
          :navigation="true"
          :modules="modules"
        >
          <swiper-slide v-for="slide in 6" :key="slide">
            <div class="card shadow">
              <img
                src="../assets/Images/analysis.png"
                class="card-img-top img-fluid"
                alt=""
              />
              <div
                class="card-body d-flex justify-content-center align-items-center"
              >
                <div>
                  <h5 class="card-title">Creativity</h5>
                  <p class="card-text creative">
                    Lorem, ipsum dolor sit amet consectetur adipisicing elit.
                    Atque sapiente animi delectus, in cumque et. Fugit, magni
                    reiciendis. Corrupti culpa, ducimus laboriosam ullam facere
                    blanditiis rerum. Perspiciatis nemo et autem!
                  </p>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </section> -->
  <section class="state">
    <div class="vision container-fluid mt-5">
      <div class="d-flex row flex-md-row flex-column-reverse">
        <div class="d-flex galaxy col-lg-6 col-md-6 col-sm-12">
          <div class="">
            <div>
              <img
                src="../assets/Images/Sight.png"
                alt=""
                class="shadow img-fluid"
              />
            </div>
            <div class="mt-2">
              <img
                src="../assets/Images/Aesthetic.png"
                alt=""
                class="shadow img-fluid"
              />
            </div>
          </div>
          <div class="">
            <div class="mt-5 ml-2">
              <img
                src="../assets/Images/Firefly.png"
                alt=""
                class="shadow img-fluid"
              />
            </div>
          </div>
        </div>
        <div
          class="d-flex col-lg-6 col-md-6 col-sm-12 align-items-center justify-content-center"
        >
          <div class="text-align-left align-items-center flourish">
            <h1 class="sixty text-primary">Our Vision</h1>
            <p class="small">
              Our vision is to be a center of innovation and excellence in
              Africa that produces world class revolutionary products and
              skilled individuals.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section>
    <div class="mission container-fluid mt-5">
      <div class="d-flex row">
        <div
          class="col-lg-6 col-md-6 col-sm-12 d-flex align-items-center justify-content-center"
        >
          <div class="text-align-center technical">
            <h1 class="sixty text-primary">Our Mission</h1>
            <p class="small">
              Developing technical manpower, products, and services to stimulate
              growth and expansion of the technology ecosystem in order to solve
              departmental challenges.
            </p>
          </div>
        </div>
        <div class="d-flex random col-lg-6 col-md-6 col-sm-12">
          <div>
            <div>
              <img
                src="../assets/Images/party.png"
                alt=""
                class="shadow img-fluid"
              />
            </div>
            <div class="mt-2">
              <img
                src="../assets/Images/peecee.png"
                alt=""
                class="shadow img-fluid"
              />
            </div>
          </div>
          <div>
            <div class="mt-5 ml-2">
              <img
                src="../assets/Images/Man.png"
                alt=""
                class="shadow img-fluid"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section>
    <div class="mandate container-fluid mt-5">
      <div class="row flex-md-row flex-column-reverse">
        <div class="d-flex col-lg-6 col-md-6 col-sm-12 stationary">
          <div>
            <div>
              <img
                src="../assets/Images/sticky.png"
                alt=""
                class="shadow img-fluid"
              />
            </div>
            <div class="mt-2">
              <img
                src="../assets/Images/white.png"
                alt=""
                class="shadow img-fluid"
              />
            </div>
          </div>
          <div>
            <div class="mt-5 ml-2">
              <img
                src="../assets/Images/systems.png"
                alt=""
                class="shadow img-fluid"
              />
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 d-flex align-items-center">
          <div class="text-align-left align-items-center">
            <h1 class="seventy text-primary">Our Mandate</h1>
            <ul class="text-align-left mentor">
              <li>Creating an excellent learning and mentoring environment.</li>
              <li>Connecting talents with job opportunities.</li>
              <li>
                Providing a continuous growth path to all skilled individuals
                within Fhenix Community
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="py-5">
      <div class="container">
        <div class="row">
          <div class="col-md-6 mb-3">
            <div class="">
              <img
                src="../assets/Images/excellence.png"
                class="img-fluid"
                alt="excellence"
              />
            </div>
          </div>
          <div class="col-md-5 d-flex justify-content-end mb-3">
            <div class="text-box">
              <h4 class="fw-bold">Excellence is our language.</h4>
              <p>
                Are you ready to take your tech career to the next level? Look
                no further than our tech training center! Our expert instructors
                are dedicated to providing hands-on training that gives you
                practical skills that will set you apart from the rest.
              </p>

              <p>
                Our training programs are tailored to your needs, ensuring that
                you get the most out of your learning experience. We pride
                ourselves on producing high-quality graduates, with a proven
                track record of connecting them with top-tier companies and job
                opportunities. Whether you're an entrepreneur, freelancer, or
                business looking to enhance your skills, our training center is
                the right place for you. Get in touch with us today and take the
                first step toward achieving your tech goals!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- <section class="team">
    <div class="container-fluid">
      <div class="d-flex justify-content-center team-text pt-2">
        <div class="mt-5 teaam">
          <h1 class="operations">The Team</h1>
          <p class="small">
            At Fhenix, we believe that our team is the key to our success. Our
            team is comprised of a diverse group of individuals with a wide
            range of skills and expertise, all dedicated to providing innovative
            solutions that will help you thrive.
          </p>
        </div>
      </div>
      <div class="row mt-4 admin">
        <div class="col-lg-4 col-md-4 mt-4">
          <img src="../assets/Images/HR.png" class="img-fluid" alt="" />
          <h4 class="name">Imaobong John</h4>
          <h6 class="role">Admin/ HR Manager</h6>
        </div>
        <div class="col-lg-4 col-md-4 mt-4">
          <img src="../assets/Images/ik.png" class="img-fluid" alt="" />
          <h4 class="name">Ikechukwu Achom</h4>
          <h6 class="role">Training Lead</h6>
        </div>
        <div class="col-lg-4 col-md-4 mt-4">
          <img src="../assets/Images/favor.png" class="img-fluid" alt="" />
          <h4 class="name">Favor Sunday</h4>
          <h6 class="role">Lead Product Designer</h6>
        </div>
        <div class="col-lg-4 col-md-4 mt-4">
          <img src="../assets/Images/nelson.png" class="img-fluid" alt="" />
          <h4 class="name">Victor Essien</h4>
          <h6 class="role">Web Developer</h6>
        </div>
        <div class="col-lg-4 col-md-4 mt-4">
          <img src="../assets/Images/nelson.png" class="img-fluid" alt="" />
          <h4 class="name">Nelson Ayanime</h4>
          <h6 class="role">Embedded Systems Engineer</h6>
        </div>
      </div>
    </div>
    <div class="jn-button d-flex justify-content-center">
      <button class="joining">Join The Team</button>
    </div>
  </section> -->
  <section class="mt-5 mb-5 container-fluid">
    <Contact />
  </section>
</template>

<script>
// @ is an alias to /src

import { Swiper, SwiperSlide } from "swiper/vue";
// import { SwiperSlide } from "swiper/vue/swiper-slide";
// import { Swiper } from "swiper/vue/swiper";
// import { SwiperSlide } from "swiper/vue/swiper-slide";
// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/css/navigation";
import { Autoplay, Pagination, Navigation } from "swiper";
import Contact from "@/components/Contact.vue";
export default {
  name: "about",
  components: {
    Swiper,
    SwiperSlide,
    Contact,
  },
  data() {
    return {
      fullText:
        "KodeHauz is a team of Nigerian programmers with an interest in providing the best ICT solution as well as necessary systems and structures to help develop capacity and skills in information technology.KodeHauz came into existence with an outstanding vision of “Bringing People and Information Technology Together” by building the requisite talent and skill pool needed to power the emerging information-based economy of the 21st century.KodeHauz was established in 2015 with a strong conviction in the power of technology to improve the world economy and to better lives. We believe the Internet is a revolutionary and powerful medium, which if used skillfully can greatly enhance and increase your existing capabilities, including marketing effectiveness, business reach, business process efficiency, and much more.",
      readMoreActivated: false,
    };
  },
  methods: {
    activateReadMore() {
      this.readMoreActivated = true;
    },
  },
  computed: {
    showText() {
      return this.readMoreActivated
        ? this.fullText
        : this.fullText.substring(0, 100);
    },
  },
  setup() {
    return {
      modules: [Autoplay, Pagination, Navigation],
    };
  },
};
</script>

<style scoped>
* {
  font-family: "Inter", sans-serif;
}

.container-fluid {
  width: 92% !important;
}

h1 {
  font-weight: 900;
  font-size: 50px;
  color: #1f1f1f;
}

section {
  color: #595959;
}

.home {
  background-image: url("../assets/Images/about-bg.png");
  min-height: 100vh;
  margin: 0 auto;
  background-size: cover;
  background-repeat: no-repeat;
  background-blend-mode: darken;
  background-color: rgba(0, 0, 0, 0.1);
}

.know {
  color: #fff !important;
  margin-top: 14rem;
  width: 45%;
  text-align: center !important;
}

.contact-text {
  text-decoration: none;
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  background-color: #335ca6;
  border-radius: 10px;
  padding: 12px 24px;
  font-weight: 500;
  border: 1px solid #335ca6;
}

.contact-text:hover {
  color: #335ca6;
  background-color: #fff;
}

.sixty {
  font-size: 64px;
  font-weight: 700;
}

.story {
  color: #595959 !important;
}

.picture {
  background-image: url("../assets/Images/Vector 6.png");
  background-repeat: no-repeat;
  background-size: 500px;
  background-position: left;
  box-shadow: none;
}
/* 
.red {
  width: 230px;
  height: 240px;
} */

/* .people {
  width: 230px;
  height: 310px;
}

.iron {
  width: 303px;
  height: 490px;
} */

.who {
  min-height: 100vh;
  background-color: rgba(249, 249, 249, 1) !important;
}

.lorme {
  color: #fff;
  text-align: center !important;
  font-size: 64px;
  font-weight: 700;
}

.circle {
  background-image: url("../assets/Images/Ellipse 71.png");
  background-position: left;
  background-repeat: no-repeat;
}

.small {
  font-size: 20px;
  color: #595959;
  font-weight: 500;
}

.portfolio-wrap {
  margin: 0 auto;
  padding: 0 auto;
}

.iron {
  position: relative;
  right: 5px;
}

.handle {
  background-color: rgba(249, 249, 249, 1);
  min-height: 100vh;
}

.values {
  background-image: url("../assets/Images/Vector 7.png");
  background-repeat: no-repeat;
  background-position: top;
  padding-top: 10px;
  padding-bottom: 5px;
}

.hood {
  align-items: center;
  width: 35%;
  text-align: center;
  color: #595959 !important;
  margin-top: 2rem;
}

.fox {
  display: flex;
  /* height: 500px !important; */
  justify-content: center;
  align-items: center;
  color: #000;
  font-size: 24px;
  font-weight: 700;
}

.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
}

.creative {
  font-size: 16px;
  /* width: 65%; */
  margin: 0 auto;
}

.vision {
  min-height: 100vh;
}

.state {
  background-image: url("../assets/Images/Vector 9.png");
  background-repeat: no-repeat;
  background-position: right;
  background-size: contain;
}

.mission {
  min-height: 100vh;
}

.mandate {
  min-height: 100vh;
}

.stationary {
  background-image: url("../assets/Images/Vector 10.png");
  background-repeat: no-repeat;
  background-position: left;
  background-size: contain;
}

.seventy {
  font-size: 64px;
  font-weight: 700;
}

.mentor {
  margin: 0 auto;
  width: 100%;
  font-size: 20px;
}

.mentor li {
  margin-top: 0px;
}

li::marker {
  color: #335ca6;
}

.team {
  background-color: rgba(249, 249, 249, 1);
  min-height: 103vh;
  background-image: url("../assets/Images/top.png");
  background-repeat: no-repeat;
  background-position: top left;
  background-size: 270px;
}

.team-text {
  text-align: center;
}

.teaam {
  width: 50%;
}

.operations {
  margin: 0 auto;
  text-align: center;
  width: 65%;
  font-size: 64px;
  font-weight: 700;
}

.admin {
  margin: 0 auto;
  text-align: center;
  width: 85%;
}

.name {
  margin-top: 16px;
  color: #1f1f1f;
  font-weight: 600;
  font-size: 24px;
}

.role {
  margin-top: 8px;
  font-size: 20px;
}

.jn-button {
  margin: 0 auto;
  padding: 50px 0;
  background-image: url("../assets/Images/below.png");
  background-repeat: no-repeat;
  background-position: right;
  background-size: 300px;
}

.joining {
  border: 2px solid #335ca6;
  border-radius: 8px;
  color: #335ca6;
  background-color: #fff;
  padding: 9px 28px;
  font-weight: 600;
}

.contact {
  background-color: rgba(249, 249, 249, 1);
  height: 100vh;
}

.information {
  width: 70%;
}

.form-div {
  width: 35%;
}

.form-info {
  color: #404040 !important;
  font-weight: 500 !important;
}

input[type="email"],
input[type="text"],
textarea {
  background-color: rgba(255, 255, 255, 1);
  width: 437px;
  height: 55px;
  border: 1px solid rgba(255, 255, 255, 1) !important;
  border-radius: 8px;
  padding-left: 24px;
}

.submit {
  background-color: rgba(51, 92, 166, 1);
  color: #fff;
  border-radius: 8px;
  border: 1px solid rgba(51, 92, 166, 1);
  padding: 12px 48px;
  font-weight: 600;
}

.text-box {
  width: 70%;
}

/* tablet view */
@media (max-width: 768px) {

  .small {
    font-size: 18px;
  }

  .sixty, .seventy {
    font-size: 40px;
  }
  .know {
    margin-top: 2rem;
    width: 67%;
  }

  .picture {
    width: 50%;
  }

  .state {
    background: transparent;
  }

  .hood {
    width: 50%;
  }

  .fox {
    /* height: 250px !important; */
  }

  .flourish {
    width: 87%;
  }

  .technical {
    width: 95%;
  }

  .mentor {
    width: 97%;
  }

  .team {
    background: transparent;
  }

  .teaam {
    width: 100%;
  }

  .admin {
    width: 100%;
  }

  .jn-button {
    background: transparent;
  }

  .text-box {
    width: 100%;
  }

  .home {
    padding-top: 100px;
  }
}

/* mobile view */
@media (max-width: 426px) {
  .know {
    width: 100%;
  }
  .swiper {
    padding: 0 !important;
  }

  .lorme {
    font-size: 24px;
  }

  .sixty {
    font-size: 24px;
  }

  .small {
    font-size: 16px;
  }

  .know {
    margin-top: 5rem;
    width: 91%;
  }

  .picture {
    width: 100%;
    box-shadow: rgba(0, 0, 0, 0.1);
  }

  .story {
    width: 100%;
    padding-top: 25px;
  }

  .values {
    background-image: url("../assets/Images/small vector7.png");
    background-repeat: no-repeat;
    background-position: top;
  }

  .hood {
    width: 100%;
  }

  .flourish {
    width: 100%;
    text-align: center;
  }

  .technical {
    width: 100%;
    text-align: center;
  }

  .seventy {
    font-size: 24px;
    text-align: center !important;
  }

  .mentor {
    width: 100%;
    font-size: 16px;
  }

  .team {
    height: 400vh;
  }

  .operations {
    font-size: 24px;
  }

  .joining {
    display: none;
  }
}
</style>
